var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-actions',{attrs:{"no-body":"","title":"معدل انجاز البرنامج التعليمي"}},[_c('vue-apex-charts',{attrs:{"type":"radialBar","height":"245","options":_vm.goalOverviewRadialBar.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }